import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api } from "../../lib/api";

const blank = { name: "", email: "", phone: "", branch: "", move_in_date: "", situation: "" };
const BRANCHES = ["Army", "Navy", "Air Force", "Marine Corps", "Coast Guard", "Space Force", "National Guard / Reserve"];

export const VeteranApplyForm = () => {
  const [f, setF] = useState(blank);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/veteran-applications", f);
      setDone(true); setF(blank);
      toast.success("Application received. We'll be in touch soon.");
    } catch { toast.error("Could not submit. Please call us instead."); }
    finally { setBusy(false); }
  };

  if (done) return (
    <div className="card-luxe text-center py-10" data-testid="veteran-apply-success">
      <CheckCircle2 className="w-10 h-10 text-[#D4AF37] mx-auto" />
      <h3 className="font-serif text-2xl mt-3">Application received</h3>
      <p className="text-white/90 mt-2 text-sm">Pastor Shalonda or Minister Jennifer Ward will contact you soon.</p>
      <button onClick={() => setDone(false)} data-testid="veteran-apply-again" className="btn-ghost-gold mt-5 !py-2 !px-4 text-sm">Submit another</button>
    </div>
  );

  return (
    <form id="veteran-apply" onSubmit={submit} data-testid="veteran-apply-form" className="card-luxe grid sm:grid-cols-2 gap-4">
      <h3 className="font-serif text-2xl sm:col-span-2">Apply for Housing</h3>
      <input required placeholder="Full name *" value={f.name} onChange={set("name")} className="input-luxe" data-testid="vet-name" />
      <input required type="tel" placeholder="Phone *" value={f.phone} onChange={set("phone")} className="input-luxe" data-testid="vet-phone" />
      <input required type="email" placeholder="Email *" value={f.email} onChange={set("email")} className="input-luxe sm:col-span-2" data-testid="vet-email" />
      <select value={f.branch} onChange={set("branch")} className="input-luxe" data-testid="vet-branch">
        <option value="">Branch of service</option>
        {BRANCHES.map((b) => <option key={b}>{b}</option>)}
      </select>
      <input type="date" value={f.move_in_date} onChange={set("move_in_date")} className="input-luxe" data-testid="vet-move-in" aria-label="Desired move-in date" />
      <textarea rows={3} placeholder="Tell us briefly about your current housing situation" value={f.situation} onChange={set("situation")} className="input-luxe sm:col-span-2" data-testid="vet-situation" />
      <button disabled={busy} className="btn-gold sm:col-span-2" data-testid="vet-submit">{busy ? "Submitting…" : "Submit Application"}</button>
    </form>
  );
};
